module.exports = __webpack_public_path__ + "img/NA.4213a4d5.png";